module.exports = __webpack_public_path__ + "static/media/ionicons.d6592091.svg";